/* Booking all items popup */
angular.module('cfn').controller('bookingSupplyPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    // This is called when the popover is shown.
    var onShow = angular.bind(this, function() {
      this.getAllItems();
    });

    $scope.goBackToCore = ang.getInParents($scope, 'goBackToCore');
    /*
	$scope.goBackToCore=function(content){
	    $scope.bookingController.goBackToCore();
    };
    */

    // Required to have all generic popover methods.
    addListPopupCode(this, $scope, null, onShow, null);

    // Loads all activated items.
    this.getAllItems = function() {
      var url = '/365FarmNet/mod/supply-service/rest/bookingmask/v1.0/ActiveOnly';
      this.listData = null;

      app.startLoading();

      $http.get(url).then(
        angular.bind(this, function(response) {
          app.finishLoading();
          this.listData = response.data;
        })
      );
    };

    // The result from the server contains an array for each item type,
    // so the arrays have to be merged for the directive.
    //	this.transformData = function(data) {
    //		var transformedData = [];
    //
    //		angular.forEach(data, function(value, key) {
    //
    //			angular.forEach(data[key], function(v, k) {
    //			    // We have to append culture name with harvest type to show it in the same column
    //				if (v.type === "SysHarvestType") {
    //					v.name = v.name+" ("+enums.HarvestTypeEnum[v.dbType.toUpperCase()]+")";
    //				}
    //				v._objectType = v.type.toLowerCase();
    //			});
    //
    //			transformedData = transformedData.concat(data[key]);
    //		});
    //		//console.log('transformedData: ', transformedData);
    //		return transformedData;
    //	};

    $scope.typeEnumOptions = ['Fertilizer', 'PlantProtectant'];

    return ($scope.bookingSupplyPopupController = this);
  }
]);
